import moment from "moment"

export const abbreviatedMonthFormat = (date: string) => {
  return moment(date).format("MMM D, YYYY")
}

export const longMonthFormat = (date: string) => {
  return moment(date).format("MMMM D, YYYY")
}

export const isInDateRange = (startDate?: string, endDate?: string) => {
  const now = moment()
  return now.isBetween(
    startDate ?? moment().subtract(1, "d"),
    endDate ?? moment().add(1, "d"),
  )
}
